<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Detail Shortcut Obat dan Alkes'">
          <template v-slot:body>
            <div class="row align-items-center">

              <!-- Profile Image -->
              <div class="col-md-4">
                <div class="d-flex justify-content-center align-items-center image-container">
                  <div style='height: 350px; width: 350px; position: relative'>
                    <img
                      class="image"
                      src="/images/default-medicine.svg"
                      @load="onImageLoad()"
                    >
                  </div>
                </div>
              </div>

              <!-- Table Data -->
              <div
                class="col"
                v-if="imgLoaded"
              >
                <table class="table mb-3">
                  <tr>
                    <td style="width: 25%"><strong>Nama </strong></td>
                    <td>{{ data.package_name }}</td>
                  </tr>
                  <tr>
                    <td style="width: 25%"><strong>Tindakan</strong></td>
                    <td>{{ data.action_name }}</td>
                  </tr>
                  <tr>
                    <td><strong>Obat/Alkes</strong></td>
                    <td>
                      <ul
                        v-for="medicines in data.display_medicine"
                        :key="medicines.id"
                      >
                        <li class="ml-5">
                          {{ medicines.name + " X " + medicines.quantity }}
                        </li>
                      </ul>
                      <span v-if="data.display_medicine.length < 1">-</span>
                    </td>
                  </tr>
                </table>

                <button
                  @click="$router.push({path: '/medicine-packages/Edit/' + data.id})"
                  class="btn mx-1 btn-success"
                ><i class="far fa-fw fa-edit"></i> Edit</button>
                <button
                  @click="deleteData"
                  class="btn mx-1 btn-danger"
                ><i class="far fa-fw fa-trash-alt"></i> Hapus</button>
              </div>

            </div>
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  data() {
    return {
      // Data
      data: {
        name: "",
      },
      // Other
      imgLoaded: false
    }
  },

  components: {
    Card,
  },

  methods: {

    onImageLoad() {
      this.imgLoaded = true
    },

    async deleteData() {
      let result = await module.delete('medicine-packages/' + this.$route.params.id)
      // If Deleted
      if (result) {
        // Redirect To List
        this.$router.push('/medicine-packages/list')
      }
    },

    async get() {
      this.data = await module.get('medicine-packages/' + this.$route.params.id)
      // If Data Not Found
      if (this.data == null) {
        // Redirect To List
        this.$router.push('/medicine-packages/list')
      }
    }

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Shortcut Obat dan Alkes", route: "" },
      { title: "Daftar Shortcut Obat dan Alkes", route: "/medicine-packages/list" },
      { title: "Detail" },
    ])
    // Get Data
    this.get()
  },
}

</script>